
import { useNavigate } from "react-router-dom";

function SideBarWithChildren({ children }) {

    const navigate = useNavigate();

    function redirectPage(url) { // переадресовать
        navigate(url);
        closeNavTab();
    }


    function clickAboutUs(e) {
        e.preventDefault();
    }

    function clickContacts(e) {
        e.preventDefault();
    }

    function closeNavTab() {
        document.querySelector('.navtab').classList.remove('navtab_visible')
    }


    return (
        <div className="navtab">
            {/* <button className="navtab__button" onClick={closeNavTab}>
                <span className="navtab__button-close">X</span>
            </button> */}
            {children}
        </div >
    )
}

export default SideBarWithChildren;